import { motion } from "framer-motion";

const partners = [
  {
    name: "GrupaQ",
    logo: "https://customer-assets.emergentagent.com/job_029f614f-0bc6-470f-b667-169a8ae993b6/artifacts/waql8ci9_logo-grupa.png",
    href: "https://grupaq.pl/",
  },
  {
    name: "ResQmed",
    logo: "https://customer-assets.emergentagent.com/job_869f1ee6-8112-4f45-b26d-d26e300ca061/artifacts/sx81cra5_resqmed-logo.png",
    href: "https://resqmed.pl/",
  },
  {
    name: "IQmed",
    logo: "https://customer-assets.emergentagent.com/job_869f1ee6-8112-4f45-b26d-d26e300ca061/artifacts/owj3be5m_IQMEDLOGO.png",
    href: "http://www.iq-med.pl/",
  },
  {
    name: "Nestlé Health Science",
    logo: "https://customer-assets.emergentagent.com/job_e86bab49-40bf-4c6b-9012-c8ea0731ae69/artifacts/ob4vyr7g_image-removebg-preview.png",
    href: "https://www.nestlehealthscience.pl/",
  },
  {
    name: "mediCAD",
    logo: "https://customer-assets.emergentagent.com/job_91d58ce5-7175-4406-bc6e-248ce703c817/artifacts/t6zaw7pr_mediCAD-logo_2.png",
    href: "https://www.medicad.eu/",
  },
  {
    name: "Smith+Nephew",
    logo: "https://customer-assets.emergentagent.com/job_869f1ee6-8112-4f45-b26d-d26e300ca061/artifacts/c3wbfoas_SNlogo.png",
    href: "https://www.smith-nephew.com/en/",
  },
];

const marqueeItems = [...partners, ...partners, ...partners, ...partners];

export const Partners = () => {
  return (
    <section
      id="partnerzy"
      className="py-8 bg-white dark:bg-[#0D0F12] overflow-hidden"
      aria-label="Partnerzy"
      data-testid="partners-section"
    >
      <motion.div
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 0.5 }}
        className="relative bg-[#F7F9F9] dark:bg-white py-10 group"
        data-testid="partners-carousel"
      >
        <div className="absolute left-0 top-0 bottom-0 w-24 sm:w-40 bg-gradient-to-r from-[#F7F9F9] dark:from-white to-transparent z-10 pointer-events-none" />
        <div className="absolute right-0 top-0 bottom-0 w-24 sm:w-40 bg-gradient-to-l from-[#F7F9F9] dark:from-white to-transparent z-10 pointer-events-none" />

        <div className="marquee-track group-hover:[animation-play-state:paused] flex items-center">
          {marqueeItems.map((partner, index) => (
            <a
              key={index}
              href={partner.href}
              target="_blank"
              rel="noopener noreferrer"
              className="flex-shrink-0 w-[180px] sm:w-[220px] lg:w-[240px] flex items-center justify-center opacity-80 hover:opacity-100 transition-opacity duration-300"
              data-testid={`partner-logo-${index}`}
            >
              <img
                src={partner.logo}
                alt={partner.name}
                className="max-h-14 sm:max-h-16 lg:max-h-[72px] max-w-[150px] sm:max-w-[180px] lg:max-w-[200px] w-auto h-auto object-contain"
                draggable={false}
              />
            </a>
          ))}
        </div>
      </motion.div>
    </section>
  );
};
